const vendorPriorityConstants = Object.freeze({
  STRATEGIC: 0,
  TACTICAL: 1,
  OCCASIONAL: 2,
});

const vendorStatusConstants = Object.freeze({
  EMPTY: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  TO_BE_VALIDATED: 3
});

const vendorBeneficiaryStatusConstants = Object.freeze({
  PENDING: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  ERROR: 3
});

export {
  vendorPriorityConstants,
  vendorStatusConstants,
  vendorBeneficiaryStatusConstants,
};

